module.exports = __webpack_public_path__ + "img/Sourcing-and-Procurement.3a247013.svg";